<!--
 * @Desc: 
 * @Author: may.li
 * @Date: 2023-04-26 15:03:11
 * @LastEditors: may.li
 * @LastEditTime: 2023-05-13 08:55:24
-->
<template>
  <div class="">
    <Modal v-model="showMangheModal"
           title="编辑盲盒"
           :loading="loading"
           :mask-closable="false"
           @on-ok="editMenghe('hezi')">
      <Spin size="large"
            fix
            v-if="showHeziLoading"
            class="totalLoad"></Spin>
      <Form ref="hezi"
            :model="hezi"
            :rules="ruleHezi"
            action="javascript:void(0)"
            :label-width="120">
        <FormItem label="位置："
                  prop="place">
          <span>{{ hezi.place }}</span>
        </FormItem>
        <FormItem label="状态："
                  prop="status">
          <RadioGroup v-model="hezi.status">
            <Radio :label="0">有商品</Radio>
            <Radio :label="1">无商品</Radio>
            <Radio :label="2">不放商品</Radio>
          </RadioGroup>
        </FormItem>
        <FormItem label="关联盒子："
                  prop="goods"
                  v-if="hezi.status == 0">
          <Select :filterable="true"
                  placeholder="请搜索"
                  v-model="hezi.goods"
                  @on-select="selectGoods">
            <Option :value="goods.good_id"
                    v-for="(goods,index) in goodsList"
                    :key="index">{{ goods.good_title }}</Option>
          </Select>
        </FormItem>
        <div class=""
             v-show="hezi.goods">
          <FormItem label="显示的盒子面："
                    prop="side"
                    v-if="hezi.status == 0">
            <RadioGroup v-model="hezi.side"
                        @on-change="changeSide">
              <Radio :label="1">面1</Radio>
              <Radio :label="2">面2</Radio>
              <Radio :label="3">面3</Radio>
              <Radio :label="4">面4</Radio>
              <Radio :label="5">顶面</Radio>
              <Radio :label="6">底面</Radio>
            </RadioGroup>
          </FormItem>
          <FormItem label="姓氏名称："
                    prop="name"
                    v-if="hezi.status == 0 && hezi.side != 5 && hezi.side != 6 ">
            <Input type="text"
                   v-model="hezi.name"
                   readonly
                   placeholder="与面自动关联"></Input>
          </FormItem>
          <FormItem label="姓氏描述："
                    prop="description"
                    v-if="hezi.status == 0 && hezi.side != 5 && hezi.side != 6 ">
            <Input type="textarea"
                   v-model="hezi.description"
                   readonly
                   placeholder="与面自动关联"></Input>
          </FormItem>
        </div>
        <!-- <FormItem label="盒子现价："
                  prop="prices"
                  v-if="hezi.status == 0">
          <Input type="number"
                 v-model="hezi.prices"
                 number
                 placeholder="与商品自动关联"
                 readonly></Input>
        </FormItem> -->
        <!-- <FormItem label="盒子库存："
                  prop="store"
                  v-if="hezi.status == 0">
          <Input type="number"
                 v-model="hezi.store"
                 number
                 placeholder="与商品自动关联"
                 readonly></Input>
        </FormItem> -->
        <FormItem label="格子抽取概率：">
          <Select v-model="hezi.good_attr_id"
                  filterable
                  clearable>
            <Option v-for="item in attrList"
                    :value="item.id"
                    :key="item.id">{{ item.attr_name }}</Option>
          </Select>
        </FormItem>

      </Form>
    </Modal>
  </div>
</template>
<script>
export default {
  data () {
    return {
      currentSide: null, // 面包含的信息
      showHeziLoading: false,
      goodsList: [],
      attrList: [],
      loading: true,
      showMangheModal: false,
      hezi: {
        id: null,
        place: null,
        name: null,
        description: null,
        prices: null,
        store: null,
        goods: null,
        side: null,
        good_attr_id: 0,
        status: 0 // 0有商品 1无商品 2不放商品
      },
      ruleHezi: {
        // name: [
        //   {
        //     type: 'string', required: true, message: '姓氏名称必须填写', trigger: 'blur'
        //   }
        // ],
        // description: [
        //   {
        //     type: 'string', required: true, message: '姓氏描述必须填写', trigger: 'blur'
        //   }
        // ],
        status: [
          {
            type: 'number', required: true, message: '状态必须选择', trigger: 'blur'
          }
        ]
      }
    }
  },
  created () {
    this.getGoodsList();
    this.getAttr();
  },
  methods: {
    /**
     * @name: 返回值
     * @param {*} val
     * @return {*}
     * @desc: 
     */
    changeSide (val) {
      this.currentSide = this.baijiaxingalbum['box' + this.hezi.side];
      this.hezi.name = this.currentSide.name;
      this.hezi.description = this.currentSide.describe;
    },
    /**
     * @name: 商品详情
     * @param {*} id
     * @return {*}
     * @desc: 
     */
    getDetail (id) {
      this.$api.mangheshopgoods.detail({ good_id: id }).then(res => {
        if (res.code == 200) {
          let info = res.result;
          this.hezi.prices = info.prices;
          this.hezi.store = info.store;
          let baijiaxingalbum = JSON.parse(info.baijiaxingalbum);
          if (this.hezi.side) {
            let currentSide = baijiaxingalbum['box' + this.hezi.side];
            this.hezi.name = currentSide.name;
            this.hezi.description = currentSide.describe;
            this.currentSide = currentSide;
          }
          this.baijiaxingalbum = baijiaxingalbum;

        }
      })
    },
    /**
     * @name: 选中商品
     * @param {*} item
     * @return {*}
     * @desc: 
     */
    selectGoods (item) {
      console.log('选中商品', item);
      let goodsId = item.value;
      this.getDetail(goodsId);
    },
    /**
     * @name: 拿所有的商品
     * @return {*}
     * @desc: 
     */
    getGoodsList () {
      let params = {
        cate_id: [6],
        page: 1,
        size: 999
      };
      this.$api.mangheshopgoods.list(params).then(res => {
        if (res.code == 200) {
          this.goodsList = res.result.list;
        }
      })
    },
    /**
     * @name: 编辑盒子
     * @param {*} name
     * @return {*}
     * @desc: 
     */
    editMenghe (name) {
      this.$refs[name].validate((vaild) => {
        // console.log('vaild', vaild)
        // console.log('hezi', this.hezi)
        if (vaild) {
          if (this.hezi.status == 0) {
            // 要关联商品
            if (!this.hezi.goods) {
              this.$Message.warning('请关联商品');
              return this.changeLoading();
            } else {
              // 关联了商品
              let params = {
                table_id: this.hezi.id,
                status: this.hezi.status,
                shop_good_id: this.hezi.goods,
                title: this.hezi.name,
                describe: this.hezi.description,
                good_attr_id: this.hezi.good_attr_id,
                thumb_type: this.hezi.side,
                thumb: this.currentSide.thumb,
                store: this.hezi.store,
                prices: this.hezi.prices
              }
              //   console.log('有图吗',params)
              console.log(this.hezi);
              this.$api.baixingqiang.createtabledata(params).then(res => {
                if (res.code == 200) {
                  console.log(111444);
                  this.changeLoading();
                  this.showMangheModal = false;
                  let obj = {
                    id: this.hezi.id,
                    img: this.currentSide.thumb,
                    trIndex: this.hezi.trIndex,
                    tdIndex: this.hezi.tdIndex,
                    status: this.hezi.status
                  }
                  this.$emit('changeHezi', obj)
                } else {
                  return this.changeLoading();
                }
              })
            }
          } else {
            // 未关联商品
            let params = {
              table_id: this.hezi.id,
              status: this.hezi.status,
              title: this.hezi.name,
              describe: this.hezi.description,
              good_attr_id: this.hezi.good_attr_id,
            };
            this.$api.baixingqiang.createtabledata(params).then(res => {
              if (res.code == 200) {
                this.changeLoading();
                this.showMangheModal = false;
                let obj = {
                  id: this.hezi.id,
                  img: '/statics/home/images/empty_gezi.png',
                  trIndex: this.hezi.trIndex,
                  tdIndex: this.hezi.tdIndex,
                  status: this.hezi.status
                }
                this.$emit('changeHezi', obj)
              } else {
                return this.changeLoading();
              }
            })
          }
        } else {
          return this.changeLoading();
        }
      })
    },
    /**
     * @desc:  获取属性
     * @para: 
     * @author: lc
     * @return {*}
     */
    getAttr: function () {
      this.$api.baixingqiangchouqurule.list().then(res => {
        if (res.code == 200) {
          this.attrList = res.result.attr;
        }
      });
      return;
    },
    /**
     * @name: 控制loading
     * @return {*}
     * @desc: 
     */
    changeLoading () {
      this.loading = false;
      this.$nextTick(() => {
        this.loading = true;
      });
    },
    /**
     * @name: 获取数据
     * @param {*} obj
     * @return {*}
     * @desc: 包含盒子在几行几列、盒子id
     */
    initFun (obj) {
      this.hezi.place = (obj.trIndex + 1) + '行' + (obj.tdIndex + 1) + '列';
      this.hezi.trIndex = obj.trIndex;
      this.hezi.tdIndex = obj.tdIndex;
      this.showMangheModal = true;
      //   console.log('获取数据', obj);
      // 查盒子详情 接口
      let params = {
        table_id: obj.id
      };
      this.hezi.id = obj.id;
      this.showHeziLoading = true;
      this.$api.baixingqiang.tabledata(params).then(res => {
        this.showHeziLoading = false;
        if (res.code == 200) {
          let info = res.result;
          this.hezi.side = info.thumb_type;
          this.hezi.status = info.status != null ? info.status : 0;
          this.hezi.goods = info.shop_good_id;
          this.hezi.name = info.title;
          this.hezi.good_attr_id = info.good_attr_id;
          console.log(this.hezi.good_attr_id)
          this.hezi.description = info.describe;
          if (this.hezi.goods) {
            this.getDetail(this.hezi.goods);
          } else {
            this.hezi.prices = null;
            this.hezi.store = null;
          }
        }
      })
    }
  }
}
</script>